import React, { useState, useEffect } from "react";
import { 
    Student, 
    Text, 
    SearchBar,
    Wrapper
} from "../components/StudentProfiles";

const useFetch = url =>
{
    const [data, setStudents] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect( () => 
    {
        const fetchData = async () =>
        {
            //fetch from api
            const res = await fetch(url);
            const data = await res.json();

            const students = data.students;

            setStudents(students);
            setLoading(false);
        }
        fetchData();
    }, [url]);

    return { data, loading };
};


const StudentProfiles = () =>
{
    const { data, loading } = useFetch("https://api.hatchways.io/assessment/students");

    const [searchNameValue, setSearchNameValue] = useState("");
    const [searchTagValue, setSearchTagValue] = useState("");
  
    const filterNames = ({ firstName, lastName }) => 
    {
        return ( firstName.toLowerCase().indexOf(searchNameValue.toLowerCase()) !== -1 || lastName.toLowerCase().indexOf(searchNameValue.toLowerCase()) !== -1 ) ;
    };

    return (
        <Wrapper>
            <SearchBar onSearch={setSearchNameValue} value={searchNameValue} placeholder="Search by name"/>
            <SearchBar onSearch={setSearchTagValue} value={searchTagValue} placeholder="Search by tag"/>
            {
                loading ? (
                    <Text>...loading</Text>
                ) : (
                    data.filter(filterNames).map( student => 
                        {
                            return (
                                <Student
                                    searchTagValue={searchTagValue}
                                    picUrl={student.pic}
                                    firstName={student.firstName}
                                    lastName={student.lastName}
                                    grades={student.grades}
                                    details={{
                                        email: student.email,
                                        company: student.company,
                                        skill: student.skill
                                    }}
                                />)
                        })
                )
            }
            
        </Wrapper>
    )
}

StudentProfiles.defaultProps = {};

export default StudentProfiles;